"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var hasCustomIntro = function (campaign) {
    var _a, _b, _c, _d, _e, _f;
    if (!!((_b = (_a = campaign.meta) === null || _a === void 0 ? void 0 : _a.assets) === null || _b === void 0 ? void 0 : _b[0])) {
        if (!((_f = (_e = (_d = (_c = campaign.meta) === null || _c === void 0 ? void 0 : _c.assets) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.sources) === null || _f === void 0 ? void 0 : _f[0])) {
            console.error('Custom intro asset is not populated');
            return false;
        }
        return true;
    }
    return false;
};
exports.default = hasCustomIntro;
